import React from 'react'

import Main from '@/components/misc/Main'
import SentryErrorBoundary from '@/components/misc/SentryErrorBoundary'

interface Props {
  children: React.ReactNode
}

const LandingWhiteLayout: React.FC<Props> = ({ children }) => (
  <div className="bg-white">
    <Main>
      <SentryErrorBoundary variant="full-screen">
        {children}
      </SentryErrorBoundary>
    </Main>
  </div>
)

export default LandingWhiteLayout
